var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2 21C16.5183 21 16.8235 20.8736 17.0485 20.6485C17.2736 20.4235 17.4 20.1183 17.4 19.8V15C17.4 14.6817 17.2736 14.3765 17.0485 14.1515C16.8235 13.9264 16.5183 13.8 16.2 13.8H9V12.6C9 12.2817 8.87357 11.9765 8.64853 11.7515C8.42348 11.5264 8.11826 11.4 7.8 11.4H4.2C3.88174 11.4 3.57652 11.5264 3.35147 11.7515C3.12643 11.9765 3 12.2817 3 12.6V19.8C3 20.1183 3.12643 20.4235 3.35147 20.6485C3.57652 20.8736 3.88174 21 4.2 21H16.2Z",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.80078 11.4V4.2C7.80078 3.88174 7.92721 3.57652 8.15225 3.35147C8.37729 3.12643 8.68252 3 9.00078 3H17.504C17.822 3.00007 18.127 3.12639 18.352 3.3512L20.6496 5.6488C20.8744 5.87376 21.0007 6.17876 21.0008 6.4968V17.4C21.0008 17.7183 20.8744 18.0235 20.6493 18.2485C20.4243 18.4736 20.119 18.6 19.8008 18.6H17.4008",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3984 6.59998H17.3984",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3984 10.2H17.3984",
    stroke: "#2A3842",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachDocument);
export default __webpack_public_path__ + "static/media/attach-document.c30eb2b89d97ea4cdfea9bff8d42b109.svg";
export { ForwardRef as ReactComponent };